/**
 * Labstep
 *
 * @module components/ResourceItem/Filter/ResourceLocation
 * @desc Select filter for resource location
 */

import { ICONS } from 'labstep-web/constants/icons';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import { PostFilterResourceLocation } from 'labstep-web/services/postFilter/filters/resourceLocation';
import type React from 'react';
import { placeholder } from './strings';
import type { IResourceItemFilterResourceLocationProps } from './types';

export const ResourceItemFilterResourceLocation: React.FC<
  IResourceItemFilterResourceLocationProps
> = ({
  setParams,
  searchParams,
  actionComponentProps,
  activeGroup,
  addPostFilter,
}) => (
  <Modal
    header={ResourceLocation.getHumanReadableEntityName(false, true)}
    content={({ toggleModal }) => (
      <EntityReadEntityContainer
        entityName={ResourceLocation.entityName}
        id={(searchParams.resource_location_id as number) || 'null'}
      >
        {({ entity: resourceLocation }) => (
          <ParamsStateContextProvider value={{}}>
            <SearchSelect
              value={resourceLocation}
              placeholder={placeholder}
              entityName={ResourceLocation.entityName}
              isClearable
              params={{
                group_id: activeGroup?.id,
              }}
              onChange={(selectedOption) => {
                if (addPostFilter) {
                  addPostFilter(
                    PostFilterResourceLocation.getNode([
                      selectedOption?.guid,
                    ]),
                  );
                } else {
                  setParams({
                    resource_location_guid: selectedOption
                      ? selectedOption.guid
                      : undefined,
                  });
                }
                toggleModal();
              }}
              usePartialSerializer
            />
          </ParamsStateContextProvider>
        )}
      </EntityReadEntityContainer>
    )}
    viewComponent={({ toggleModal }) => (
      <ActionComponent
        type="option"
        icon={ICONS.resource_location.primary}
        text={ResourceLocation.getHumanReadableEntityName(
          false,
          true,
        )}
        onClick={toggleModal}
        {...actionComponentProps}
      />
    )}
  />
);

export default withActiveGroup(ResourceItemFilterResourceLocation);
